import type { EvaluationDataset } from '../../services/api/evaluation.api.js';
import { zEvaluationDatasetCreate } from '../../generated/api/zod.gen.js';

export const TARGET_TYPE_LABELS: Record<EvaluationDataset['targetType'], string> = {
  agent_template: 'Agent template',
  skill: 'Skill',
  workflow: 'Workflow',
  tool: 'Tool',
  model: 'Model',
};

/** The target types a new dataset may take: the create route's own list (a `model` dataset is a judge's calibration). */
export const TARGET_TYPE_OPTIONS = zEvaluationDatasetCreate.shape.targetType.options.map((value) => ({
  value,
  label: TARGET_TYPE_LABELS[value],
}));
